import { shallowRef } from 'vue';

import createI18n from '@/lib/i18next/createI18n';

// innerT is synchronously access in components.
// this is a dummy placeholder that wont be called and will be
// replaced by a blocking setup call during app initialize
let innerT = function(str) {
  return str;
};

// innerT is a plain `let` Vue can't track. trackI18n() reads this ref so the
// caller re-renders when i18n (re)initialises and innerT is swapped.
const i18nVersion = shallowRef(0);

function trackI18n() {
  // eslint-disable-next-line no-unused-expressions
  i18nVersion.value;
}

export async function setup() {
  innerT = await window.globalLibs.i18NextPromise;
  i18nVersion.value++;
}

export default function t(strText, ...tail) {
  trackI18n();
  const spTranslated =
    typeof window._sp === 'function' ? window._sp(strText) : strText;
  return innerT(spTranslated, ...tail);
}

export function useI18n() {
  // Wrapper, not the innerT reference: a captured reference never updates.
  return function translate(strText, ...tail) {
    trackI18n();
    return innerT(strText, ...tail);
  };
}

/**
 * @param{Object} p
 *  @param{String} p.module
 *  @param{String} p.file
 *  @param{String} p.app // add app translation support
 *
 * @return{Function}
 */
export function getTranslations({ module = '', file = '', app = '' }) {
  if (!file) {
    throw new Error('file name is required');
  }

  function translation(translationKey, ...vars) {
    trackI18n();
    return innerT(
      `${app ? `apps:${app}:` : ''}${
        module ? `${module}:` : ''
      }${file}:${translationKey}`,
      ...vars
    );
  }

  return translation;
}

export async function changeLanguage(languageCode) {
  try {
    await createI18n();
    await window.i18nInstance.changeLanguage(languageCode);
  } finally {
    // changeLanguage mutates the shared instance, so a mid-flight failure can
    // still leave resources partially swapped. Bump either way or renders stale.
    i18nVersion.value++;
  }
}
